export const triggerBlobDownload = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

/**
 * File name announced by a Content-Disposition header, e.g. `attachment; filename=control-unit.log`.
 * The RFC 5987 `filename*` form takes precedence because it carries the exact (possibly non-ASCII) name.
 */
export const getAttachmentFileName = (contentDisposition: string | null): string | undefined => {
  if (!contentDisposition) return undefined

  const extended = contentDisposition.match(/filename\*\s*=\s*(?:[\w-]+'[^']*')?([^;]+)/i)
  if (extended) {
    try {
      const fileName = decodeURIComponent(extended[1].trim().replace(/^"|"$/g, ''))
      if (fileName) return fileName
    } catch {
      // Malformed percent-encoding, fall back to the plain filename parameter
    }
  }

  const plain = contentDisposition.match(/filename\s*=\s*(?:"([^"]*)"|([^;]*))/i)
  const fileName = (plain?.[1] ?? plain?.[2])?.trim()
  return fileName || undefined
}
